import React from "react";
import styled from "styled-components";
import TaskCreationRow from "./TaskCreationRow";
import SofaIcon from "../assets/svg/sofa.svg?react";
import OpenIcon from "../assets/svg/arrow-small-forward.svg?react";
import DownIcon from "../assets/svg/icon-arrow-small-down.svg?react";
import UpIcon from "../assets/svg/icon-arrow-small-up.svg?react";
import { FixaSkeleton } from "@coworker/apprestructured/src/shared/wrappers/FixaSkeleton/FixaSkeleton";

const Container = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) => props.insights && "margin-top: -15px"}
`;

const TitleWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const GrayText = styled("div")`
  font-weight: normal;
  font-size: 14px;
  line-height: 1.5;
  color: var(--grey700);
`;

const Title = styled("div")`
  font-weight: bold;
  color: var(--black);
`;
const ProductImage = styled("img")`
  height: 70px;
`;
const InsightImage = styled("img")`
  height: 70px;
  min-width: 73px;
  max-width: 110px;
  margin-right: -35px;
`;
const WrappedOpenIcon = styled(OpenIcon)`
  margin-right: -8px;
`;

const noop = () => null;

export function ControlledProductDetails({
  title,
  subtitle,
  descriptive,
  formattedNumber,
  onClick = noop,
  insights,
  showOnlyLocation,
  smallImage,
  editEnabled,
  openEditInsights,
}) {
  return (
    <Container margin={insights && !showOnlyLocation}>
      {!!insights && !showOnlyLocation && (
        <InsightImage
          data-testid="productImage"
          src={smallImage}
          insights={insights}
        />
      )}
      <TaskCreationRow
        data-testid="productContent"
        onClick={onClick}
        minheight={showOnlyLocation ? "" : "75px"}
        left={!insights && <SofaIcon />}
        showOnlyLocation={showOnlyLocation}
        right={
          insights ? null : smallImage ? (
            <ProductImage data-testid="productImage" src={smallImage} />
          ) : (
            <FixaSkeleton height="72px" width="72px" />
          )
        }
      >
        {insights ? (
          <TitleWrapper>
            <Title data-testid="productTitle">{title}</Title>
            {editEnabled ? (
              openEditInsights ? (
                <UpIcon />
              ) : (
                <DownIcon />
              )
            ) : (
              <WrappedOpenIcon />
            )}
          </TitleWrapper>
        ) : (
          <TitleWrapper>
            <Title data-testid="productTitle">{editEnabled ? "" : title}</Title>
          </TitleWrapper>
        )}
        <GrayText data-testid="productDescription">
          {editEnabled ? "" : subtitle || descriptive}
        </GrayText>
        <GrayText data-testid="productNumber">{formattedNumber}</GrayText>
      </TaskCreationRow>
    </Container>
  );
}
